import { createCall, spellbook } from "@sdk/spellbook";

import { withAccountAuthHeaders } from "./apiHelpers";

const endpoint = spellbook("/v1/feedback/{feedbackId}").GET();

export async function getFullFeedback(params: typeof endpoint.types.P) {
    const call = createCall(endpoint, (r) => fetch(withAccountAuthHeaders(r)));
    return await call({ params });
}
